import {React, observer, _, pluralize, Fragment} from '@api'
import {Button} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import {useGroupByGroupStore} from '@modules'
import {GroupByGroup} from './'
import * as css from './GroupByGroupChildrenGroups.css'

export const GroupByGroupChildrenGroups = observer(function GroupByGroupChildrenGroups() {
  const parentStore = useGroupByGroupStore(),
    {
      catalog: {groupBy: {settings: {groupView}}}, isExpanded: isParentExpanded, nextGroup
    } = parentStore

  // useEffect(function refetchOnUpdate() {
  //   return reaction(() => stores.product.refetchGroup, () => {
  //     if (stores.product.refetchGroup === true) {
  //       stores.product.refetchGroup = false
  //       refetch({
  //         variables: isVLPView ? vlpWhereClause : childQueryVariables
  //       })
  //     }
  //   })
  // }, [stores.product.refetchGroup])

  // useEffect(() => {
  //   queryManager.registerRefetchInfo({
  //     refetch,
  //     id:          group,
  //     path:        childPath,
  //     groupName:   childGroupName,
  //     description: `Load child group '${childGroupName}' for ${groupName} - ${group} - ${info.name}`
  //   })
  //
  // }, [refetch])

  const {childGroupStore, ddEventsNoDragStart} = parentStore,
    {shouldRenderAsCssGrid} = childGroupStore
  // childColumns = settings?.childColumns ? settings.childColumns : defaultGroupingSettings.childColumns,
  // columns = columnView ? childGroupStore.mgr.groupCount : childGroupStore.mgr.groupCount ? Math.min(childGroupStore.mgr.groupCount, childColumns) : childColumns
  // useAsync(async () => {
  //   return childGroupStore.maybeRunChildGroupsQuery({skip: !isExpanded || !everVisible})
  // }, [isExpanded, everVisible, childGroupStore.queryVariables, childGroupStore.grouping?.orderBy.order, childGroupStore.grouping?.orderBy.field])

  //const levelAttribute = {[`data-level-${level}-count`]: childGroupStore.grouping.itemCount},

  return (
    //   <div
    //   className={classNames(css.root, {[css.grid]: levelOfDetail == 0 || catalog.stackView})}
    //   data-child-group-name={childGroupStore.groupName}
    //   data-level={level}
    //   data-type='GroupByGroupChildrenGroups'
    //   {...levelAttribute}
    //   data-visible={isExpanded}
    //   data-stack={catalog.stackView}
    //   data-stack-view={!hasChildGroup ? stackView : undefined}
    //   data-orientation={orientation}
    //   data-leaf-group-count={childGroupStore.level + 1 == hierarchy.length ? itemCount : undefined}
    //   style={{'--group-count': groupCount} as any}
    // >
    <Fragment>
      {shouldRenderAsCssGrid ? <ChildrenGroupsGrid/>
                             : groupView === 'card'
                               ? (
                                 <div className={css.childrenGroupItems}
                                      data-view={groupView}
                                      data-parent-view={parentStore.groupView}
                                      data-next-group-is-expanded={nextGroup?.store?.isExpanded}
                                      data-visible={isParentExpanded}
                                      onDoubleClick={parentStore.onToggleExpandCollapse}
                                      {...ddEventsNoDragStart}
                                 >
                                   <GroupByGroupChildrenGroupsContent/>
                                 </div>
                               )
                               : <GroupByGroupChildrenGroupsContent/>
      }
    </Fragment>
    //</div>
  )
})

const GroupByGroupChildrenGroupsContent = observer(function GroupByGroupChildrenGroupContent() {
  const {
    childGroupStore, mustTerms, mustNotTerms, props: parentProps
  } = useGroupByGroupStore(),
    {mgr: {initialLoad, groupCountOrLastCount, partitionedGroups, onClickLoadMore, remainingToLoad}, shouldRenderAsCssGrid, grouping} = childGroupStore

  return initialLoad
         ? null //<LoadingIndicator key='loader' className={css2.loading}/> <CircularProgress size={24} className={css.dataLoadingProgress}/> // show loading in the header instead
         : <Fragment>
           {partitionedGroups.map((g, i) => {
             if (!_.isArray(g)) {
               return (
                 <GroupByGroup
                   key={g.key}
                   info={g}
                   index={i}
                   inGridCell={shouldRenderAsCssGrid}
                   level={childGroupStore.level}
                   groupName={childGroupStore.groupName}
                   path={childGroupStore.path}
                   mustTerms={mustTerms}
                   mustNotTerms={mustNotTerms}
                   group={g.key}
                   groupCount={groupCountOrLastCount}
                 />)
             } else {
               return g.map((collapsedGroup) => (
                                   <GroupByGroup
                                     key={collapsedGroup.key}
                                     inGridCell={shouldRenderAsCssGrid}
                                     info={collapsedGroup}
                                     level={childGroupStore.level}
                                     groupName={childGroupStore.groupName}
                                     path={childGroupStore.path}
                                     mustTerms={mustTerms}
                                     mustNotTerms={mustNotTerms}
                                     group={collapsedGroup.key}
                                     groupCount={groupCountOrLastCount}
                                   />))
             }
           })}
           {remainingToLoad > 0 && <Tooltip2 content={`${remainingToLoad.toLocaleString()} remaining`}>
		       <Button text={`Load More ${parentProps.info.title} -> ${pluralize(grouping.title)}`}
		               className={css.loadMore}
		               onClick={onClickLoadMore}/>
	       </Tooltip2>}
           {/*{!columnView && columns > 1 && <div className={css.groupBreak}/>}*/}
         </Fragment>
})
const ChildrenGroupsGrid = observer(function ChildrenGroupsGrid() {
  const parentStore = useGroupByGroupStore(),
    {groupBy, childGroupStore, settings: {columnView, fullHeight}, isExpanded, ddEventsNoDragStart} = parentStore,
    {mgr: {level, groupCountOrLastCount}} = childGroupStore,
    {settings: {groupView}} = groupBy

  return ((
    <div className={css.gridContainer}
         data-level={level}
         data-type='ChildGroupsGridContainer'
         data-parent-showing-inline-aggregation-details={parentStore?.showingInlineAggregationDetails}
         data-view={childGroupStore.grouping.allowCardMode && childGroupStore.grouping.fieldDefinition?.esIndex ? groupView : 'flat'}
         style={{
           '--item-count': groupCountOrLastCount,
           '--header-top': `${parentStore.headerTop}px`,
           '--header-height': `${parentStore.headerHeight}px`} as any}
         {...ddEventsNoDragStart}
    >
      <div className={css.grid}
           data-grid={true}
           data-type={'GroupByGroupChildrenGroups'}
           data-full-height={fullHeight}
           data-column-view={columnView}
           data-expanded={isExpanded}
           data-columns={parentStore.columns ?? groupBy.individualGroupSettings.childColumns}
      >
        <GroupByGroupChildrenGroupsContent/>
      </div>
    </div>))
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupByGroupChildrenGroups.tsx